module.exports = __webpack_public_path__ + "assets/img/error.92f79fa0.svg";